import React, { useEffect, useState } from 'react'
import DatePicker from "react-datepicker";
import Grid from "@mui/material/Grid2";
import { Box, Button, ButtonGroup, FormControl, IconButton, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { ProjectList } from 'src/stateManagement/redux/slices/shared/interfaces';
import { useSelector } from "react-redux";
import { selectGtoState, useDispatch, gerenciaTecnicaSlice } from "src/stateManagement/redux";
import { selectMainState } from "../../../../stateManagement/redux";
import "./styles.scss"
import { getTagLgetListOfOptimizationActivities, getTagLgetListOfOptimizationActivitiesInExcel } from 'src/shared/util/requestDataServer';
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import SelectBoxSearch from 'src/shared/components/select_box_search';
import TuneIcon from '@mui/icons-material/Tune';
import { Filter, FilterDrawer, FilterList } from 'src/shared/modules/filterDrawer';
import UnfoldMoreDoubleIcon from '@mui/icons-material/UnfoldMoreDouble';
import UnfoldLessDoubleIcon from '@mui/icons-material/UnfoldLessDouble';
import DownloadIcon from '@mui/icons-material/Download';
import { convertArrayOfObjectsToCSV } from 'src/shared/util/functions';
import moment from "moment";

const defaultFilters: FilterList[] = [
    {
        name: 'Fecha Inicio',
        field: 'startDate',
        type: 'date',
        action: 'equalAfter',
        buttons: [],
        options: []
    },
    {
        name: 'Fecha Fin',
        field: 'endDate',
        type: 'date',
        action: 'equalBefore',
        buttons: [],
        options: []
    },
    {
        name: 'Campo',
        field: 'projectId',
        type: 'select',
        action: 'include',
        buttons: [],
        options: []
    },
    {
        name: 'Metodo',
        field: 'method',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ['BM', 'BCP', 'ESP', 'Gas Lift']
    },
    {
        name: 'Sector',
        field: 'zone',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ["BTS1", "BTS2", "BTN2", "BTN3", "BTNB", "LGN2", "LGS1", "LGN1", "LGS2", "BTNA"]
    },
    {
        name: 'Estado',
        field: 'status',
        type: 'select',
        action: 'include',
        buttons: [],
        options: [
            { id: "", name: "Todos" },
            { id: "pending", name: "Por Analizar" },
            { id: "analyzing", name: "Evaluar Luego" },
            { id: "completed", name: "Analiazada" }
        ]
    },
]

export const ActivityAnalyzer = () => {
    const dispatch = useDispatch();
    const { configModules } = useSelector(selectMainState);
    const options: string[] = ["Locación"];
    const [inputValueFilter, setInputValueFilter] = useState<string>("");
    const [selectedOption, setSelectedOption] = useState(options[0]);
    const [dataForTable, setDataForTable] = useState<any[]>([])
    const [dataFromServer, setDataFromServer] = useState<any>()
    const [showFilters, setshowFilters] = useState(false)
    const [filteredData, setFilteredData] = useState<Filter[]>([]);
    const [filters, setfilters] = useState<FilterList[]>(defaultFilters)
    const [activeView, setactiveView] = useState("")
    const [columns, setColumns] = useState<GridColDef[]>([])
    const [loadingSearch, setLoadingSearch] = useState(false)

    const [buttonGroup, setButtonGroup] = useState<any[]>([
        { name: "Requerimientos", number: 0 },
        { name: "Análisis", number: 0 },
        { name: "Opciones de Optimización", number: 0 }
    ])

    const [data, setData] = useState<Location[]>([]);

    const paginationModel = { page: 0, pageSize: 10 };

    useEffect(() => {
        if (configModules?.projectList) {

            const newFilters = [...defaultFilters];

            const locationIndex = defaultFilters.findIndex((filter) => filter.field === 'projectId');

            const projectOptions = configModules?.projectList?.map((project: ProjectList) => ({
                id: project.projectId,
                name: project.name
            }))

            if (locationIndex !== -1) {
                newFilters[locationIndex].options = projectOptions;
            } else {
                newFilters.push({
                    name: 'Campo',
                    field: 'projectId',
                    type: 'select',
                    action: 'include',
                    buttons: [],
                    options: projectOptions
                });
            }

            setfilters(newFilters)
        }

    }, [configModules])

    // function to fetch the list of optimization activities
    const handleSearch = async () => {
        try {
            setLoadingSearch(true)

            const serverFilters = ['startDate', 'endDate', 'projectId', 'status', 'method', 'zone'];

            const body: any = {}

            serverFilters.forEach((filter) => {
                const data = filteredData.find((f) => f.field === filter);
                if (data && data.value) {
                    let value = data.value;
                    if (filter === 'startDate' || filter === 'endDate') {
                        if (value && value._isAMomentObject) {
                            value = value.format('YYYY-MM-DD');
                        }
                    }
                    if (value !== "") {
                        body[filter] = value;
                    }
                }
            })

            const data = await getTagLgetListOfOptimizationActivities(body)

            setDataFromServer(data)

            const numberAnalist = data?.analists?.length || 0;
            const numberRequirements = data?.requirements?.length || 0;
            const numberOptimizationOptions = data?.optimizationActivity?.length || 0;

            setButtonGroup([
                { name: "Requerimientos", number: numberRequirements },
                { name: "Analizis", number: numberAnalist },
                { name: "Opciones de Optimizacion", number: numberOptimizationOptions }
            ])

            setactiveView("Requerimientos");
            setshowFilters(false);
        } finally {
            setLoadingSearch(false)
        }
    }

    useEffect(() => {
        let data = [];

        if (activeView === "Requerimientos") {
            data = dataFromServer?.requirements || [];
            console.log({ dataFromServer });
            setDataForTable(data);
            setColumns([
                // { field: "optimizationActivityId", headerName: "id", width:10 },
                { field: "requiredDate", headerName: "Fecha de Solictud", minWidth: 150, flex: 1 },
                { field: "executionDate", headerName: "Fecha de Ejecutado", minWidth: 150, flex: 1 },
                { field: "locationName", headerName: "Locación", minWidth: 150, flex: 1 },
                { field: "zone", headerName: "Sector", minWidth: 100, flex: 1 },
                { field: "method", headerName: "Metodo", minWidth: 100, flex: 1 },
                { field: "pot", headerName: "Pot", minWidth: 100, flex: 1 },
                { field: "requesterUserName", headerName: "Requerido Por", minWidth: 150, flex: 1 },
                { field: "variableName", headerName: "Accion", minWidth: 150, flex: 1 },
                { field: "state", headerName: "Estado", minWidth: 150, flex: 1 },
                { field: "comments", headerName: "Comentario", minWidth: 150, flex: 1 },
                { field: "blocker", headerName: "Bloqueantes", minWidth: 150, flex: 1 },
                { field: "priority", headerName: "Prioridad", minWidth: 150, flex: 1 },
                { field: "priorityReason", headerName: "Razón de Prioridad", minWidth: 150, flex: 1 },
                { field: "priorityExtraReason", headerName: "Razón de Prioridad Extra", minWidth: 150, flex: 1 },
            ])
        } else if (activeView === "Analizis") {
            data = dataFromServer?.analists || [];
            setDataForTable(data);
            setColumns([
                { field: "fieldActivityDate", headerName: "Fecha", minWidth: 180, flex: 1 },
                {
                    field: "executionDate",
                    headerName: "Fecha análisis",
                    minWidth: 180,
                    flex: 1,
                    valueGetter: (_value, row) => {
                        const raw = row?.executionDate;
                        if (!raw) return "";
                        return moment(raw).local().format("DD-MM-YY HH:mm");
                    },
                },
                { field: "locationName", headerName: "Locación", minWidth: 150, flex: 1 },
                { field: "method", headerName: "Metodo", minWidth: 100, flex: 1 },
                { field: "pot", headerName: "Pot", minWidth: 100, flex: 1 },
                { field: "fieldActivityStartTime", headerName: "Hora Inicio Act.", minWidth: 150, flex: 1 },
                { field: "fieldActivityEndTime", headerName: "Hora Fin Act.", minWidth: 150, flex: 1 },
                { field: "zone", headerName: "Sector", minWidth: 100, flex: 1 },
                { field: "crew", headerName: "Cuadrilla", minWidth: 100, flex: 1 },
                { field: "engineers", headerName: "Ingenieros", minWidth: 200, flex: 1 },
                { field: "field", headerName: "Campo", minWidth: 120, flex: 1 },
                { field: "technology", headerName: "Tecnología", minWidth: 150, flex: 1 },
                { field: "activityType", headerName: "Tipo Actividad", minWidth: 150, flex: 1 },
                { field: "diagnosis", headerName: "Diagnóstico", minWidth: 250, flex: 1 },
                { field: "recommendation", headerName: "Recomendación", minWidth: 250, flex: 1 },
                { field: "initialActivityState", headerName: "Estado Inicial Act.", minWidth: 150, flex: 1 },
                { field: "finalActivityState", headerName: "Estado Final Act.", minWidth: 150, flex: 1 },
                { field: "thp", headerName: "THP", minWidth: 150, flex: 1 },
                { field: "surfaceUnitBrand", headerName: "Marca Balancín", minWidth: 150, flex: 1 },
                { field: "surfaceUnitModel", headerName: "Modelo Balancín", minWidth: 150, flex: 1 },
                { field: "freePolisRod", headerName: "Barra Libre", minWidth: 150, flex: 1 },
                { field: "strokeLength", headerName: "Carrera", minWidth: 150, flex: 1 },
                { field: "spm", headerName: "SPM", minWidth: 150, flex: 1 },
                { field: "rpm", headerName: "RPM", minWidth: 150, flex: 1 },
                { field: "crankHole", headerName: "Tiro", minWidth: 150, flex: 1 },
                { field: "maxLoad", headerName: "Carga_max", minWidth: 150, flex: 1 },
                { field: "minLoad", headerName: "Carga_min", minWidth: 150, flex: 1 },
                { field: "liquidLevel", headerName: "Nivel (pies)", minWidth: 150, flex: 1 },
                { field: "pumpSumergence", headerName: "Sumergencia (pies)", minWidth: 150, flex: 1 },
                { field: "pip", headerName: "PIP (lpc)", minWidth: 150, flex: 1 },
                { field: "pwf", headerName: "Pwf (lpc)", minWidth: 150, flex: 1 },
                { field: "acusticVelocity", headerName: "Velocidad Acústica", minWidth: 150, flex: 1 },
                { field: "fieldComment", headerName: "Comentario Campo", minWidth: 200, flex: 1 },
                { field: "weedsCondition", headerName: "Cond. Maleza", minWidth: 120, flex: 1 },
                { field: "fozaCondition", headerName: "Cond. Fosa", minWidth: 150, flex: 1 },
                { field: "stuffingBoxStatus", headerName: "Estatus Stuffing", minWidth: 150, flex: 1 },
                { field: "sonologStatus", headerName: "Estatus Sonolog", minWidth: 150, flex: 1 },
                { field: "secondaryValve4InchStatus", headerName: "Estatus Válvula 2da 4\"", minWidth: 180, flex: 1 },
                { field: "sampleValveStatus", headerName: "Estatus Válv. Muestra", minWidth: 180, flex: 1 },
                { field: "brakesStatus", headerName: "Estatus Frenos", minWidth: 120, flex: 1 },
                { field: "selectorStatus", headerName: "Estatus Selector", minWidth: 150, flex: 1 },
                { field: "vfdAccessStatus", headerName: "Acceso Vareador", minWidth: 150, flex: 1 },
                { field: "headerAccessStatus", headerName: "Acceso Cabezal", minWidth: 150, flex: 1 },
                { field: "wellReespaced", headerName: "Pozo Reespaciado", minWidth: 150, flex: 1, type: 'boolean' },
                { field: "eptBeforeInValue", headerName: "EPT (Anterior-In)", minWidth: 150, flex: 1 },
                { field: "eptAfterInValue", headerName: "EPT (Posterior-In)", minWidth: 150, flex: 1 },
                { field: "dynoCardTaked", headerName: "Carta", minWidth: 180, flex: 1, type: 'boolean' },
                { field: "fluidLevelValue", headerName: "Nivel", minWidth: 180, flex: 1, type: 'boolean' },
                { field: "pressureTestTaken", headerName: "Prueba Presión", minWidth: 150, flex: 1, type: 'boolean' },
                { field: "valveTesTaken", headerName: "Prueba Válvula", minWidth: 150, flex: 1, type: 'boolean' },
                { field: "samplesTaken", headerName: "Muestras Tomadas", minWidth: 150, flex: 1, type: 'boolean' },
                { field: "state", headerName: "Estado", minWidth: 150, flex: 1 },
                { field: "analyzedBy", headerName: "Analizado Por", minWidth: 150, flex: 1 },
                { field: "statusCandidate", headerName: "Estatus Candidato", minWidth: 150, flex: 1 },
                { field: "bottomHoleCondition", headerName: "Condición de Fondo", minWidth: 180, flex: 1 },
                { field: "subBottomHoleCondition", headerName: "Sub-Condición Fondo", minWidth: 180, flex: 1 },
                { field: "fillageBottomHole", headerName: "Llenado Fondo (%)", minWidth: 150, flex: 1, type: 'number' },
                { field: "plungerDiameter", headerName: "Diámetro Pistón", minWidth: 150, flex: 1, type: 'number' },
                { field: "eptAnalysis", headerName: "Análisis EPT", minWidth: 150, flex: 1, type: 'number' },
                { field: "theoreticalProduction", headerName: "Producción Teórica", minWidth: 180, flex: 1, type: 'number' },
                { field: "pumpEfficiency", headerName: "Eficiencia Bomba (%)", minWidth: 180, flex: 1, type: 'number' },
                { field: "theoreticalProductionAfterEfficiency", headerName: "Prod. Teórica (c/Eficiencia)", minWidth: 200, flex: 1, type: 'number' },
                { field: "mainOptimizationActivity", headerName: "Actividad de Optimizacion", minWidth: 200, flex: 1 },
                { field: "isCBO", headerName: "Es CBO", minWidth: 200, flex: 1 },
                { field: "mainOptimizationActivitySimulated", headerName: "Simulado", minWidth: 90, flex: 1, type: 'boolean' },
                { field: "isWellWithMultiplesTDSEntries", headerName: "Repetitivo TDS", minWidth: 90, flex: 1, type: 'boolean' }
            ])
        } else if (activeView === "Opciones de Optimizacion") {
            data = dataFromServer?.optimizationActivity || [];
            setDataForTable(data);
            setColumns([
                // { field: "optimizationActivityId", headerName: "id", width:10 },
                { field: "requiredDate", headerName: "Fecha de Solicitud", minWidth: 150, flex: 1 },
                { field: "executionDate", headerName: "Fecha de Ejecutado", minWidth: 150, flex: 1 },
                { field: "locationName", headerName: "Locación", minWidth: 150, flex: 1 },
                { field: "zone", headerName: "Sector", minWidth: 100, flex: 1 },
                { field: "method", headerName: "Metodo", minWidth: 100, flex: 1 },
                { field: "pot", headerName: "Pot", minWidth: 100, flex: 1 },
                { field: "requesterUserName", headerName: "Requerido Por", minWidth: 150, flex: 1 },
                { field: "variableName", headerName: "Accion", minWidth: 150, flex: 1 },
                { field: "isCBO", headerName: "EsCBO", minWidth: 150, flex: 1 },
                { field: "isWellWithMultiplesTDSEntries", headerName: "Repetitivo TDS", minWidth: 150, flex: 1 },
                { field: "state", headerName: "Estado", minWidth: 150, flex: 1 },
                { field: "comments", headerName: "Comentario", minWidth: 150, flex: 1 },
                { field: "simulationDate", headerName: "Fecha Simulado", minWidth: 150, flex: 1 },
                { field: "productionBefore", headerName: "Pot Antes", minWidth: 100, flex: 1 },
                { field: "expectedProduction", headerName: "Pot Esperada", minWidth: 100, flex: 1 }
            ])
        }


    }, [dataFromServer, activeView])


    const handleSelectChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setSelectedOption(event.target.value);
        setInputValueFilter("");
    };

    const handleFilterInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValueFilter(event.target.value);
    };

    const handleSelectOptionFilter = (filter: Filter) => {
        const extraFilter = filteredData.filter(f => f.name !== filter.name);
        setFilteredData([...extraFilter, filter]);
        // dispatch(gerenciaTecnicaSlice.actions.setLocationListFilter(JSON.stringify([...extraFilter, filter])));
    };

    const onClickTypeTabs = (type: string) => {
        setactiveView(type);
    }

    const handleResetSearch = () => {
        setFilteredData([]);
        setData([]);
    }

    const handleDownloadCSV = () => {
        try {
            if (dataForTable.length > 0) {

                const dataToExport: any[] = []

                dataForTable.forEach((row) => {
                    const newRow: any = {};
                    columns.forEach((col) => {
                        newRow[col?.headerName || col.field] = row[col.field] || "";
                    });

                    if (['Requerimientos', 'Opciones de Optimizacion'].includes(activeView)) {
                        newRow['optimizationActivityId'] = row['optimizationActivityId'];
                        newRow['fecha de mesa tecnica'] = ""
                        newRow['analizado con'] = "";
                        newRow['Comentario mesa tecnica'] = "";
                    }

                    dataToExport.push(newRow);
                });

                const csv = convertArrayOfObjectsToCSV(dataToExport);
                const utf8Bom = "\uFEFF"; // UTF-8 BOM
                const csvWithBom = utf8Bom + csv;
                const blob = new Blob([csvWithBom], { type: "text/csv;charset=utf-8;" });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.setAttribute("hidden", "");
                a.setAttribute("href", url);
                const currentTime = new Date().toISOString().replace(/[:.]/g, "-");
                a.setAttribute("download", `${activeView}_${currentTime}.csv`);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        } catch (error) {
            console.log({ error });
        }
    };

    const handleDownloadExcel = async() => {
        const serverFilters = ['startDate', 'endDate', 'projectId', 'status', 'method', 'zone'];

        const body: any = {
            returnExcel: true
        }

        serverFilters.forEach((filter) => {
            const data = filteredData.find((f) => f.field === filter);
            if (data && data.value) {
                let value = data.value;
                if (filter === 'startDate' || filter === 'endDate') {
                    if (value && value._isAMomentObject) {
                        value = value.format('YYYY-MM-DD');
                    }
                }
                if (value !== "") {
                    body[filter] = value;
                }
            }
        })

        const data = await getTagLgetListOfOptimizationActivitiesInExcel(body)

    }

    return (
        <Grid container spacing={2}>
            <Grid size={12} sx={{ mt: 1 }}>
                <Box className="header-container">
                    <SelectBoxSearch
                        options={options}
                        selectedOption={selectedOption}
                        onOptionChangeSelectBox={handleSelectChange}
                        onValueChangeInput={handleFilterInput}
                        inputValue={inputValueFilter}
                    />
                    <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                        <ButtonGroup variant="outlined" aria-label="Basic button group" sx={{ mr: 2 }}>
                            {buttonGroup.map((button, index) => (
                                <Button
                                    key={index}
                                    variant={activeView === button.name ? 'contained' : 'outlined'}
                                    size='small'
                                    onClick={() => onClickTypeTabs(button.name)}
                                    sx={{
                                        overflow: 'hidden',
                                    }}
                                >
                                    {button.name} ({button.number})
                                </Button>
                            ))}
                        </ButtonGroup>
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={() => setshowFilters(!showFilters)}
                        >
                            <TuneIcon />
                        </IconButton>
                    </Grid>
                </Box>
            </Grid>
            <FilterDrawer
                showFilters={showFilters}
                filters={filters}
                filteredData={filteredData}
                setshowFilters={setshowFilters}
                handleSelectOptionFilter={handleSelectOptionFilter}
                resetFilters={handleResetSearch}
                onQueryAction={handleSearch}
                loadingQuery={loadingSearch}
            />
            <Grid size={12}>
                {dataForTable.length === 0 ? (
                    <Grid container spacing={2} sx={{ mb: 2, justifyContent: 'center', alignItems: 'center', height: 500 }}>
                        <Typography variant="h6" sx={{ textAlign: 'center', width: '100%' }}>
                            No hay datos para mostrar. Con la combinacion de filtros seleccionada.
                        </Typography>
                    </Grid>

                ) : (
                    <>
                        <Grid sx={{ m: 2, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <IconButton
                                size="small"
                                color="primary"
                                onClick={() => handleDownloadExcel()}
                            >
                                <DownloadIcon />
                            </IconButton>

                        </Grid>
                        <DataGrid
                            rows={dataForTable.map((row, index) => ({ ...row, id: row.id || index }))}
                            columns={columns}
                            initialState={{ pagination: { paginationModel } }}
                            pageSizeOptions={[10, 20, 50, 100]}
                            checkboxSelection={false}
                            sx={{
                                border: 0,
                                "& .MuiDataGrid-columnHeader": {
                                    backgroundColor: "#316EBC",
                                    color: "#fff",
                                    fontWeight: "bold",
                                },
                                height: {
                                    md: `calc(100vh - 270px)`,
                                    lg: `calc(100vh - 270px)`,
                                },
                            }}
                            getRowId={(row) => row.id}
                        />
                    </>
                )}


            </Grid>
        </Grid>
    )
}
